import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(seleccionarHerramientaGrupoMascaras);

import { put, select } from 'redux-saga/effects';
import { getPantalla, barraHerramientasSelectors } from '../../selectors';
import { PANTALLA_VENTANA_ID } from '../../constantes';
import { ENMASCARAR_ID, FOCO_ID, PERSIANA_ID, RESETEAR_ID } from '../../herramientas/constantes';
import * as actionsMascaras from '../../mascaras/actions';
import * as selectorsMascaras from '../../mascaras/selectors';
import * as actionsCartulina from '../../cartulina/actions';
import * as selectorsCartulina from '../../cartulina/selectors';
import * as actionsPersiana from '../../persiana/actions';
import * as selectorsPersiana from '../../persiana/selectors';
import * as Util from '../../util';
export function seleccionarHerramientaGrupoMascaras(action) {
  var mascarasActivas, cartulinaActiva, persianaActiva, pantallaId, boton, mensaje;
  return _regeneratorRuntime.wrap(function seleccionarHerramientaGrupoMascaras$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(selectorsMascaras.getActivas);

        case 2:
          mascarasActivas = _context.sent;
          _context.next = 5;
          return select(selectorsCartulina.getActiva);

        case 5:
          cartulinaActiva = _context.sent;
          _context.next = 8;
          return select(selectorsPersiana.getActiva);

        case 8:
          persianaActiva = _context.sent;
          _context.t0 = action.herramientaId;
          _context.next = _context.t0 === ENMASCARAR_ID ? 12 : _context.t0 === FOCO_ID ? 26 : _context.t0 === PERSIANA_ID ? 40 : _context.t0 === RESETEAR_ID ? 54 : 69;
          break;

        case 12:
          if (!mascarasActivas) {
            _context.next = 17;
            break;
          }

          _context.next = 15;
          return put(actionsMascaras.desactivar());

        case 15:
          _context.next = 25;
          break;

        case 17:
          if (!cartulinaActiva) {
            _context.next = 20;
            break;
          }

          _context.next = 20;
          return put(actionsCartulina.desactivar());

        case 20:
          if (!persianaActiva) {
            _context.next = 23;
            break;
          }

          _context.next = 23;
          return put(actionsPersiana.desactivar());

        case 23:
          _context.next = 25;
          return put(actionsMascaras.activar());

        case 25:
          return _context.abrupt('break', 69);

        case 26:
          if (!cartulinaActiva) {
            _context.next = 31;
            break;
          }

          _context.next = 29;
          return put(actionsCartulina.desactivar());

        case 29:
          _context.next = 39;
          break;

        case 31:
          if (!mascarasActivas) {
            _context.next = 34;
            break;
          }

          _context.next = 34;
          return put(actionsMascaras.desactivar());

        case 34:
          if (!persianaActiva) {
            _context.next = 37;
            break;
          }

          _context.next = 37;
          return put(actionsPersiana.desactivar());

        case 37:
          _context.next = 39;
          return put(actionsCartulina.activar());

        case 39:
          return _context.abrupt('break', 69);

        case 40:
          if (!persianaActiva) {
            _context.next = 45;
            break;
          }

          _context.next = 43;
          return put(actionsPersiana.desactivar());

        case 43:
          _context.next = 53;
          break;

        case 45:
          if (!mascarasActivas) {
            _context.next = 48;
            break;
          }

          _context.next = 48;
          return put(actionsMascaras.desactivar());

        case 48:
          if (!cartulinaActiva) {
            _context.next = 51;
            break;
          }

          _context.next = 51;
          return put(actionsCartulina.desactivar());

        case 51:
          _context.next = 53;
          return put(actionsPersiana.activar());

        case 53:
          return _context.abrupt('break', 69);

        case 54:
          _context.next = 56;
          return select(getPantalla);

        case 56:
          pantallaId = _context.sent;
          _context.next = 59;
          return select(barraHerramientasSelectors.getBoton, action.herramientaId);

        case 59:
          boton = _context.sent;
          mensaje = pantallaId === PANTALLA_VENTANA_ID ? boton.mensajeVentana || boton.mensaje : boton.mensaje;

          if (!Util.confirm(mensaje)) {
            _context.next = 68;
            break;
          }

          _context.next = 64;
          return put(actionsMascaras.resetear());

        case 64:
          _context.next = 66;
          return put(actionsCartulina.resetear());

        case 66:
          _context.next = 68;
          return put(actionsPersiana.resetear());

        case 68:
          return _context.abrupt('break', 69);

        case 69:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}